<template lang="pug">
  .room.anchor-room
    .divice-block(:class="warningFlag1")
      .divice-block-1
        DoubleGraph(:opts="humidity1" :series="humidity1Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" )
    .divice-block(:class="warningFlag2")
      .divice-block-1
        DoubleGraph(:opts="humidity2" :series="humidity2Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" )
    .divice-block.divice-block-info
      SwitchStatus.divice-block-thin(title="钢箱梁上游除湿机组运行状态" :series="SwitchStatusData")
      RunningTimeBig.divice-block-time(title="钢箱梁上游除湿机组累计运行时间" :series="RunningTimeData")
    .divice-block.divice-block-info
      SwitchStatus.divice-block-thin(title="钢箱梁下游除湿机组运行状态" :series="SwitchStatusData1")
      RunningTimeBig.divice-block-time(title="钢箱梁上游除湿机组累计运行时间" :series="RunningTimeData1")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
export default {
  name: 'steelBoxGirder',
  data () {
    return {
      timer: null,
      warningFlag1: '',
      warningFlag2: '',
      SwitchStatusData: null,
      RunningTimeData: null,
      SwitchStatusData1: null,
      RunningTimeData1: null,
      humidity1: {
        title: '上游钢箱梁温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity1Data: null,
      humidity2: {
        title: '下游钢箱梁温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity2Data: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapOpts1: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 100,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapOpts2: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 100,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  mounted () {
    this.getDatas()
    this.getLineDatas()
    this.timer = setInterval(() => {
      this.getDatas()
      this.getLineDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    refreshData () {
      this.getDatas()
      this.getLineDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
        this.getLineDatas()
      }, this.REFRESH_SECOND)
    },
    getDatas () {
      this.$http.get('/deviceData/Station?stationId=bcb52722-e9c8-40ee-aa1f-e8988ea969ce').then(res => {
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(__data, 'SinglePieHistogramWrapData1', 'ba0f241b-6b5a-4b03-9165-5579ce4483e7', '770df550-5253-4b79-ae5f-d52b0aaa239b', 'warningFlag1')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData2', '7c9d64fc-182d-4038-b4c1-c0deff5d4445', '4ea435ee-b4e5-4546-a434-a9d68b5e3296', 'warningFlag2')
        this.SwitchStatusData = {
          data: __data['7451fa2d-a37a-43b3-aa64-ed8948d41eea'].value,
          isError: __data['7451fa2d-a37a-43b3-aa64-ed8948d41eea'].errorLevel
        }
        this.SwitchStatusData1 = {
          data: __data['0a558d5c-73a3-4f7f-af70-38189c85e1b9'].value,
          isError: __data['0a558d5c-73a3-4f7f-af70-38189c85e1b9'].errorLevel
        }
        this.RunningTimeData = __data['1f2a003d-8e95-4716-8bea-dd7d72ba65d3'].value
        this.RunningTimeData1 = __data['2719fc03-7dfb-490c-a694-8039419fb522'].value
      })
    },
    GetDeviceData (id) {
      return this.$http.get('/statistics/DeviceData?deviceId=' + id + '&interval=BY_HOUR&insertBlankData=true')
    },
    getLineDatas () {
      const that = this
      this.$http.all([this.GetDeviceData('ba0f241b-6b5a-4b03-9165-5579ce4483e7'), this.GetDeviceData('770df550-5253-4b79-ae5f-d52b0aaa239b')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity1Data', that, 'warningFlag1')
          })
        )
      this.$http.all([this.GetDeviceData('7c9d64fc-182d-4038-b4c1-c0deff5d4445'), this.GetDeviceData('4ea435ee-b4e5-4546-a434-a9d68b5e3296')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity2Data', that, 'warningFlag2')
          })
        )
    },
    setPieHisData (datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (datas[data2Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (datas[data1Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    dealData (res1, res2, name, that, warnName) {
      const __data = {}
      const __data1 = {}
      const _list1 = res1.data.dataList // .splice(-10)
      _list1.forEach((el, index) => {
        __data[el.dataDate] = el.value
      })
      const _list2 = res2.data.dataList // .splice(-10)
      _list2.forEach((el, index) => {
        __data1[el.dataDate] = el.value
      })
      that[name] = {
        data1: __data,
        data2: __data1
      }
      if (res1.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res1.data.errorLevel
      }
      if (res2.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res2.data.errorLevel
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block {
    width: calc(50% - 10px);
    height: calc(50% - 40px);
  }
  .divice-block {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
  .divice-block-info {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    background-color: transparent;
    padding: 0;
    box-shadow: none;
  }
  .divice-block-thin {
    height: 42px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
  }
  .divice-block-time {
    height: calc(100% - 60px);
    width: 100%;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
  }
  .divice-block-1 {
    width: 75%;
    height: 100%;
  }
  .divice-block-2 {
    width: 24%;
    height: 96%;
  }
}
</style>
